import { lazy, Suspense } from 'react';
import { AdminLayout } from 'components/themes/admin';

const InterviewForms = lazy(() => import('modules/admin/master/InterviewForms'));

const InterviewFormsPage = (props) => (
  <AdminLayout>
    <Suspense fallback={null}>
      <InterviewForms />
    </Suspense>
  </AdminLayout>
);

export default InterviewFormsPage;